module.exports = __webpack_public_path__ + "img/ico-3.ffd77d67.svg";